// actions.js

import axios from 'axios';
import Cookies from 'js-cookie';

export default {
    
    async fetchGetMenuTree({ commit, rootGetters }){
        try {
            // Получаем токен из состояния хранилища
            const access_token = rootGetters.access_token;

            // Создаем объект конфигурации для запроса с заголовком авторизации
            const config = {
                headers: {
                    'Authorization': `${access_token}`
                }
            };

            // Выполняем GET запрос с использованием Axios и передаем конфигурацию
            const response = await axios.post(`${process.env.VUE_APP_APIGATEWAY}/api/v1/menu-tree/sidebar`, {}, config);

            // Пишем в стор
            commit('updateMenuTree', response.data)
        } catch (error) {
            console.log('error fetchGetMenuTree', error)
        }
    },

    // Получение дерева меню
    async fetchMenuItems({ commit, rootGetters }) {
        try {
            const access_token = rootGetters.access_token;
            const config = {
                headers: {
                    'Authorization': `${access_token}`
                }
            };

            const response = await axios.get(`${process.env.VUE_APP_APIGATEWAY}/api/v1/menu-items/tree`, config);
            
            // Сортируем пункты меню по полю order в порядке убывания
            const sortMenuItems = (items) => {
                if (!Array.isArray(items)) return items;
                
                return items.sort((a, b) => (b.order || 0) - (a.order || 0))
                    .map(item => ({
                        ...item,
                        children: item.children ? sortMenuItems(item.children) : []
                    }));
            };

            const sortedData = sortMenuItems(response.data);
            commit('updateMenuItems', sortedData);
            return sortedData;
        } catch (error) {
            console.error('Error fetching menu items:', error);
            throw error;
        }
    },

    // Получение wiki ссылки по пути
    async getWikiUrlByPath({ state, dispatch }, path) {
        try {
            // Если в state нет items, загружаем их
            if (!state.menuItems || !state.menuItems.length) {
                await dispatch('fetchMenuItems');
            }

            const findItem = (items, targetPath) => {
                if (!Array.isArray(items)) return '';
                
                for (const item of items) {
                    if (!item) continue;
                    
                    if (item.url === targetPath && item.wiki) {
                        return item.wiki;
                    }
                    
                    if (item.children && Array.isArray(item.children)) {
                        const found = findItem(item.children, targetPath);
                        if (found) return found;
                    }
                }
                return '';
            };

            return findItem(state.menuItems, path);
        } catch (error) {
            console.error('Error getting wiki URL:', error);
            return '';
        }
    },

    // Обновление wiki ссылки для пункта меню
    async updateMenuItemWiki({ rootGetters }, { menuItemId, wikiLink }) {
        try {
            const access_token = rootGetters.access_token;
            const config = {
                headers: {
                    'Authorization': `${access_token}`
                }
            };

            const response = await axios.put(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/menu-items/${menuItemId}`,
                { wiki: wikiLink },
                config
            );
            return response.data;
        } catch (error) {
            console.error('Error updating menu item wiki:', error);
            throw error;
        }
    },
    async updateMenuItemOrder({ rootGetters }, { menuItemId, order }) {
        try {
            const access_token = rootGetters.access_token;
            const config = {
                headers: {
                    'Authorization': `${access_token}`
                }
            };

            const response = await axios.put(
                `${process.env.VUE_APP_APIGATEWAY}/api/v1/menu-items/${menuItemId}`,
                { order: order },
                config
            );
            return response.data;
        } catch (error) {
            console.error('Error updating menu item wiki:', error);
            throw error;
        }
    }
};
